import { render, staticRenderFns } from "./usersAddView.vue?vue&type=template&id=319b523c&scoped=true&"
import script from "./usersAddView.vue?vue&type=script&lang=js&"
export * from "./usersAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b523c",
  null
  
)

export default component.exports